import { API_URL } from "env";

async function deleteFeature(featureId: number) {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/features/${featureId}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to delete feature");
        }
        return data || null;
    }
    catch (error) {
        console.error("Error deleting feature:", error);
        return null;
    }
}
export default deleteFeature;